import { BehaviorSubject } from '../core/observer/BehaviorSubject';
import { crystalTypes } from '../core/gameConstants';
import { GAME_MODES, GAME_SCENE } from '../core/constats';

export const CANVAS_GAME_LOADED = new BehaviorSubject(false);

export const gameState = new BehaviorSubject({ parent: null });
export const ACTIVE_ODD = new BehaviorSubject(crystalTypes.crystal_blue);
export const GAME_MODE = new BehaviorSubject(GAME_MODES.MOBILE);
export const GAME_SCENE_STATE = new BehaviorSubject(GAME_SCENE.MAIN);
export const SPIN_AMOUNT = new BehaviorSubject([]);
export const SPIN_AMOUNT_ACTIVE = new BehaviorSubject(0);

export const AUTO_SPIN_COUNTS = new BehaviorSubject([5, 10, 20, 50, 100, Infinity]);
export const AUTO_SPIN_COUNT = new BehaviorSubject(Infinity);
export const AUTO_SPIN_INDEX = new BehaviorSubject(0);
export const AUTO_SPIN_STATE = new BehaviorSubject(false);
export const AUTO_SPIN_BUTTON_STATE = new BehaviorSubject(true);

export const LAST_RESULTS = new BehaviorSubject([]);
export const LAST_RESULTS_BONUS = new BehaviorSubject([]);

export const USER_DATA = new BehaviorSubject({ id: 12345678 });

export const LOADING_STATE = new BehaviorSubject(true);

export const HISTORY_ICON_STATE = new BehaviorSubject(null);
export const INFORMATION_ICON_STATE = new BehaviorSubject(null);
export const SOUND_ICON_STATE = new BehaviorSubject(false);

export const BALANCE_VALUE = new BehaviorSubject('');
export const LAST_WIN_VALUE = new BehaviorSubject('');

export const PRE_BONUS_CRYSTALS_STATE = new BehaviorSubject({
  [crystalTypes.crystal_yellow]: 0,
  [crystalTypes.crystal_green]: 0,
  [crystalTypes.crystal_magenta]: 0,
  [crystalTypes.crystal_blue]: 0,
});
export const FREE_SPINS_STATE = new BehaviorSubject(0);
export const MULTIPLIER_STATE = new BehaviorSubject(0);

export const PRE_BONUS_RE_SPINS_LEFT_STATE = new BehaviorSubject(3);
export const PRE_BONUS_ID = new BehaviorSubject(null);

export const GAME_PAD_SPIN_ACTIVE = new BehaviorSubject(true);

export const PRE_BONUS_RESPONSE = new BehaviorSubject(null);
export const PRE_BONUS_RESPONSE_ANIMATE = new BehaviorSubject(new Set([0, 1, 2, 3, 4, 5, 6, 7, 8]));

export const SPINE_RESPONSE = new BehaviorSubject(null);
export const BONUS_RESPONSE = new BehaviorSubject(null);
export const BONUS_RESPONSE_TOTAL_AMOUNT = new BehaviorSubject(0);

export const HISTORY_LIST = new BehaviorSubject([]);

export const WHEEL_ROTATION_STATE = new BehaviorSubject(false);
export const ODD_CRYSTAL_ACTIVE_STATE = new BehaviorSubject(true);

export const BIG_WIN_STATE = new BehaviorSubject(false);
export const BIG_WIN_AMOUNT = new BehaviorSubject(0);

export const BET_AMOUNT_CHANGE_STATE = new BehaviorSubject(true);
export const SPIN_COUNT_CHANGE_STATE = new BehaviorSubject(true);

export const FREE_SPINS_DATA_STATE = new BehaviorSubject([]);

export const BONUS_COST_AMOUNT = new BehaviorSubject(null);

export const SCREEN_TRANSACTION_STATE = new BehaviorSubject(false);
export const HAS_BUY_BONUS = new BehaviorSubject(true);

export const IS_DATA_RECEIVED = new BehaviorSubject(false);
export const IS_AUTHENTICATED = new BehaviorSubject(false);
export const ACCESS_TOKEN = new BehaviorSubject('');

